import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from '@tanstack/react-router'
import { useCallback, useMemo } from 'react'
import { Tab, TabsButtonsProps } from '@/components/common/Tabs/types'
import { TabsButtons } from '@/components'

export const BillingTabs: React.FC = () => {
    const { t } = useTranslation('translations')
    const { pathname } = useLocation()
    const navigate = useNavigate()

    const config: Array<Omit<Tab, 'content'> & { path: string }> = useMemo(
        () => [
            {
                id: 'payablesSummary',
                label: t('billing_and_payments.tabs.buttons.payables_summary'),
                path: '/billing-and-payments/payables-summary',
            },
            {
                id: 'billHistory',
                label: t('billing_and_payments.tabs.buttons.bill_history'),
                path: '/billing-and-payments/bill-history',
            },
        ],
        [t]
    )

    const onChange = useCallback(
        (id: string) => {
            const obj = config.find((obj) => obj.id === id)

            if (obj) {
                void navigate({ to: obj.path })
            }
        },
        [config, navigate]
    )

    const tabs: TabsButtonsProps['tabs'] = config.map(
        ({ path: _path, ...tab }) => tab
    )
    const activeTab = config.find((obj) => obj.path === pathname)?.id ?? ''

    return (
        <>
            <TabsButtons
                tabs={tabs}
                activeTabId={activeTab}
                onChange={onChange}
                className="grid h-full grid-rows-[auto,1fr]"
            />
        </>
    )
}
